<ng-container *transloco="let t">
@if (versionCheckService.showUpdateBar()) {
  <div class="version-banner">
    <div class="version-banner__content">
      <svg class="version-banner__icon" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/>
        <path d="M3 3v5h5"/>
        <path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16"/>
        <path d="M16 16h5v5"/>
      </svg>
      <span class="version-banner__text">{{ t('dialogs.version.available') }}</span>
      <button class="version-banner__btn" (click)="versionCheckService.reloadApp()">{{ t('dialogs.version.reload') }}</button>
    </div>
    <button class="version-banner__dismiss" (click)="versionCheckService.dismissUpdateBar()" [attr.aria-label]="t('dialogs.version.dismiss')">
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
  </div>
}
</ng-container>
